module.exports = new __parcel__URL__("contribution1Slide1.79348e8e.png").toString();